import {ReferenceAnnotationMarkedImages} from './reference-annotation-markedImages';

export class ReferenceAnnotation {

  imageName : string;
  lat: number;
  long: number;
  height: number;
  turnOn: boolean;
  entityRef: string = null;
  entityObj: any = null;
  pinRef: any = null;
  /*latAccuracy: number;
  longAccuracy: number;
  heightAccuracy: number;*/
  referenceAnnotationMarkedImages : ReferenceAnnotationMarkedImages[];


  constructor(imageName: string, lat: number, long: number, height: number, turnOn: boolean/*, latAccuracy: number, longAccuracy: number, heightAccuracy: number*/) {
    this.imageName = imageName;
    this.lat = lat;
    this.long = long;
    this.height = height;
    this.turnOn = turnOn;
    this.referenceAnnotationMarkedImages = null;
    /*this.latAccuracy = latAccuracy;
    this.longAccuracy = longAccuracy;
    this.heightAccuracy = heightAccuracy;*/
  }


}
